"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DnpColumnDecisionApplier = void 0;
const dnp_column_decision_1 = require("./dnp-column-decision");
const dnp_metadata_value_1 = require("./dnp-metadata-value");
var DnpRuleVerdict;
(function (DnpRuleVerdict) {
    DnpRuleVerdict["NotFitted"] = "not_fitted";
    DnpRuleVerdict["Fitted"] = "fitted";
    DnpRuleVerdict["NoOpinion"] = "no_opinion";
})(DnpRuleVerdict || (DnpRuleVerdict = {}));
class DnpColumnDecisionApplier {
    static derive(decision, metadata) {
        if (decision.kind === dnp_column_decision_1.DnpColumnDecisionKind.NoDnpColumn) {
            return { isDnp: false, sourceColumn: null };
        }
        for (const rule of decision.rules) {
            const verdict = DnpColumnDecisionApplier.judge(rule, metadata?.[rule.column]);
            if (verdict !== DnpRuleVerdict.NoOpinion) {
                return { isDnp: verdict === DnpRuleVerdict.NotFitted, sourceColumn: rule.column };
            }
        }
        return { isDnp: false, sourceColumn: null };
    }
    static judge(rule, raw) {
        const value = dnp_metadata_value_1.DnpMetadataValue.normalize(raw);
        if (value === null) {
            return DnpRuleVerdict.NoOpinion;
        }
        if (rule.kind === dnp_column_decision_1.DnpColumnRuleKind.Marker) {
            return dnp_metadata_value_1.DnpMetadataValue.isMarker(value) ? DnpRuleVerdict.NotFitted : DnpRuleVerdict.NoOpinion;
        }
        if (rule.positiveValues.some((positive) => dnp_metadata_value_1.DnpMetadataValue.normalize(positive) === value)) {
            return DnpRuleVerdict.NotFitted;
        }
        if (rule.negativeValue !== null && dnp_metadata_value_1.DnpMetadataValue.normalize(rule.negativeValue) === value) {
            return DnpRuleVerdict.Fitted;
        }
        return DnpRuleVerdict.NoOpinion;
    }
}
exports.DnpColumnDecisionApplier = DnpColumnDecisionApplier;
//# sourceMappingURL=dnp-column-decision-applier.js.map